export default __webpack_public_path__ + "static/media/ic_trash.b0e1c129.svg";